// ======================================================================
// File Name       : ContentNotificationDetailContainer.js
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Button, Form } from 'react-bootstrap';
import { Redirect, Link } from 'react-router-dom';
import ContentDetail from '../../components/content/ContentNotificationDetail';
import * as ContentAction from '../../actions/content/ContentAction';
import * as Constant from '../../constants/index';
import { CONTENT_NOTIFICATION_DETAIL_TYPE } from '../../constants/ContentConstant';
import * as Path from '../../constants/PathConstants';
import { canAccessRoute } from '../../utils/AuthedUtils';
import { CONTENT_DRILL_NOTIFICATION_EDIT } from '../../constants/FunctionConstants';
import * as MessageTemplate from '../../constants/MessageTemplate';
import DialogConfirm from '../../components/DialogConfirm';
import { shouldHideBackBtn } from '../../utils/index';
import Header from '../../components/Header';


class ContentNotificationDetailContainer extends Component {
  constructor() {
    super();
    this.state = {
      notificationDetail: {
        notifyMessageList: [],
        notifyMessageSetSecernId: '',
        notifyMessageSetName: '',
      },
      isExistIdInList: false,
      linkEdit: '',
    };
    this.getContentNotificationDetail = this.getContentNotificationDetail.bind(this);
    this.backPage = this.backPage.bind(this);
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
    this.deleteNotification = this.deleteNotification.bind(this);
  }

  componentWillMount() {
    this.props.dispatch(ContentAction.resetContentNotificationRegister());
  }

  componentDidMount() {
    const params = {};
    if (this.props.match.params.id) {
      params.notifyMessageSetSecernId = this.props.match.params.id;
    }
    this.props.dispatch(ContentAction.contentNotificationSearch(params)).then(() => {
      this.getContentNotificationDetail(this.props, false);
    });
  }

  componentWillReceiveProps(nextProps) {
    const { notification } = nextProps.content;
    if (!this.state.isExistIdInList) {
      this.getContentNotificationDetail(nextProps, true);
    }
  }

  getContentNotificationDetail(props, isReceivedProps) {
    const { content, match, dispatch } = props;
    const { notification } = content;
    const { search } = notification;
    const { notifyMessageList } = search;
    if (
      (isReceivedProps && match.params.id && notifyMessageList.length > 0) ||
      (!isReceivedProps && match.params.id)
    ) {
      const index = notifyMessageList.findIndex(
        item => item.notifyMessageSetSecernId === match.params.id,
      );
      if (index >= 0) {
        const notificationDetail = notifyMessageList[index];
        const isExistIdInList = true;
        const linkEdit = `/${Path.CONTENT}/${Path.CONTENT_DRILL_NOTIFICATION}/${notificationDetail.notifyMessageSetSecernId}/edit`;
        this.setState({
          notificationDetail,
          isExistIdInList,
          linkEdit,
        });
      } else if (isReceivedProps) {
        this.backPage();
      } else {
        const params = {
          notifyMessageSetSecernId: match.params.id,
        };
        this.props.dispatch(ContentAction.contentNotificationSearch(params));
      }
    } else {
      this.backPage();
    }
  }

  openDeleteConfirmDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showModal: true });
  }

  onDeleteCancel() {
    this.setState({ showModal: false });
  }

  backPage() {
    this.props.history.push(Path.CONTENT_DRILL_NOTIFICATION_LIST);
  }
  deleteNotification() {
    const params = {
      notifyMessageSetSecernId: this.state.notificationDetail.notifyMessageSetSecernId,
    };
    this.props.dispatch(ContentAction.deleteContentNotificationMessage(params));
  }
  render() {
    const { content } = this.props;
    let isRegisterUpdateSuccessfully = false;
    if (content && content.notification && content.notification.isRegisterUpdateSuccessfully) {
      isRegisterUpdateSuccessfully = content.notification.isRegisterUpdateSuccessfully;
    }
    this.refsToValidate = [];
    if (isRegisterUpdateSuccessfully) {
      return <Redirect to="/content/notification/top" />;
    }
    const canAccess = canAccessRoute(CONTENT_DRILL_NOTIFICATION_EDIT);
    const showBackBtn = !shouldHideBackBtn(this.props.location);
    return (
      <div>
        <Header name="通知メッセージ情報の詳細"/>
        <ContentDetail
          notificationData={this.state.notificationDetail}
          isConfirmDialog={CONTENT_NOTIFICATION_DETAIL_TYPE.PAGE}
        />
        <Col sm={12} className="text-center">
          <Form className='form-horizontal'>
            <Form.Group className="margin-top-20 text-center">
              {showBackBtn && <Button variant="primary" className="btn-96 margin-10" onClick={this.backPage}>
                戻る
              </Button>}
              {canAccess && (
                <Link
                  className="btn btn-primary btn-96 margin-10"
                  role="button"
                  to={{ pathname: this.state.linkEdit }}
                >
                  編集
                </Link>
              )}
              {canAccess && (
                <Button
                  variant="primary"
                  className="btn-96 margin-10"
                  onClick={this.openDeleteConfirmDialog.bind(this, MessageTemplate.MSG_DEL_NOTIFICATION, null)}
                >
                  削除
                </Button>
              )}
            </Form.Group>
          </Form>
        </Col>
        <DialogConfirm
          showModal={this.state.showModal}
          onCancel={this.onDeleteCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.deleteNotification}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{ content: state.content, auth: state.authed.authedUser },
});

export default connect(mapStateToProps)(ContentNotificationDetailContainer);
